// extracted by mini-css-extract-plugin
export default {"topNav":"sX-z","category":"tX-z","noArrow":"uX-z","alternative":"vX-z","topLevelNavItem":"wX-z","navContainer":"xX-z","subcategoryHeading":"yX-z","subcategory":"zX-z"};